import React from "react";
import BreadCrumb from "../BreadCrumb";
import PaytheDoor from "../FreeCancellationGuarantee/PaytheDoor";
import Refund from "../FreeCancellationGuarantee/Refund";
import SecuraPayment from "../FreeCancellationGuarantee/SecuraPayment";
import Unconditionalmoney from "../FreeCancellationGuarantee/Unconditionalmoney";
import Installment from "./Installment";

const StaticPage = ({ ssr }) => {
  if (ssr.RoutingTypeId == "Installment") return <Installment />;

  return (
    <>
      <Unconditionalmoney />
      <Refund />
      <SecuraPayment />
      <PaytheDoor />
    </>
  );
};

export default StaticPage;
